export default "__VITE_ASSET__B3TUKh9q__"